var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M845 5109 c-666 -54 -845 -300 -845 -1164 0 -516 62 -777 225 -941 148 -149 328 -203 746 -225 305 -16 657 6 829 50 195 51 329 144 411 286 38 66 83 207 103 325 40 231 41 766 2 1000 -36 221 -92 349 -200 455 -131 131 -303 189 -630 215 -148 11 -494 11 -641 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3886 4898 c-57 -16 -129 -91 -144 -150 -8 -30 -12 -143 -12 -317 l0 -271 -285 0 c-236 0 -292 -3 -323 -16 -79 -33 -132 -110 -132 -194 0 -88 38 -152 115 -193 38 -21 55 -22 332 -25 l292 -3 3 -292 c3 -277 4 -294 25 -332 40 -76 105 -115 188 -115 85 0 160 48 196 125 17 36 19 69 19 328 l0 287 273 0 c325 0 353 5 415 76 96 109 68 264 -59 328 l-53 26 -288 0 -288 0 0 289 0 289 -28 53 c-47 89 -149 134 -246 107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925 2340 c-366 -20 -559 -82 -700 -224 -163 -164 -225 -425 -225 -941 0 -698 119 -975 472 -1096 154 -52 389 -79 697 -79 804 0 1060 152 1147 680 25 150 36 468 25 697 -20 406 -78 600 -221 743 -119 119 -281 180 -550 209 -138 14 -483 21 -645 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3695 2340 c-594 -31 -813 -196 -891 -670 -25 -151 -36 -476 -25 -701 22 -416 76 -596 226 -744 99 -99 198 -145 392 -184 190 -39 584 -53 859 -31 371 30 559 105 686 272 123 162 178 436 178 887 0 303 -27 552 -76 699 -70 211 -219 351 -434 412 -208 58 -538 79 -915 60z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.d6b2f9d2b0726e9e9a2f9da94ee1da72.svg";
export { ForwardRef as ReactComponent };